export default __webpack_public_path__ + "static/media/img-05.6887a8c2.jpg";